export const activeStylesObject = ({
  theme
}) => ({
  color: theme.color['text-core-default'],
  backgroundColor: theme.color['fill-field-hover'],
  borderRadius: theme.borderRadius['100'],
  '&::before': {
    content: "''",
    // not a typo, content requires an explicit quoted string
    borderLeft: `${theme.borderWidth['300']} solid ${theme.color['icon-interactive-default']}`,
    height: '100%',
    left: theme.space['0'],
    position: 'absolute',
    top: theme.space['0'],
    borderRadius: theme.borderRadius['100']
  }
});